<template>
  <div class="feature">
    <div class="title">
       {{ $t("home.feature_in_recognise_by") }}
    </div>
    <div class="content">
      <div class="icons-section">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/smartCitiesTechColor.png" alt="">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/startupDailyColor.png" alt="">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/marketingInAsiaStartup.png" alt="">
      </div>
    </div>
  </div>
</template>


<script>
export default {
  
}
</script>


<style lang="scss" scoped>

.feature{
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title{
  color: #314455;
  font-family: Poppins-Bold;
  font-size: 16px;
  line-height: 22px; 
}

.icons{
  width: 85px;
  height: auto;
}
.icons-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 33px;
  padding: 48px 0 32px
}
</style>
